import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation, Trans } from 'react-i18next';

export default function DiscountCard(props) {

  const { t } = useTranslation();

  const useStyles = makeStyles({
    myDiscountCard: {
      backgroundColor: "#F2F4F7",
      flexGrow: 1,
      minWidth: "400px",
      display: "flex",
      flexDirection: "column",
      alignContent: "space-around",
      justifyContent: "space-between",
      "@media (max-width: 766px)": {
         minWidth: "269px"
      }
    },
    myDiscountImg: {
      backgroundSize: "cover",
      position: "relative",
      height: "272px"
    },
    myDiscountDegradation: {
      height: "100%",
      background: "linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.00259416) 6.67%, rgba(0, 0, 0, 0.010653) 13.33%, rgba(0, 0, 0, 0.024498) 20%, rgba(0, 0, 0, 0.0442234) 26.67%, rgba(0, 0, 0, 0.0695324) 33.33%, rgba(0, 0, 0, 0.0995652) 40%, rgba(0, 0, 0, 0.132807) 46.67%, rgba(0, 0, 0, 0.167193) 53.33%, rgba(0, 0, 0, 0.200435) 60%, rgba(0, 0, 0, 0.230468) 66.67%, rgba(0, 0, 0, 0.255777) 73.33%, rgba(0, 0, 0, 0.275502) 80%, rgba(0, 0, 0, 0.289347) 86.67%, rgba(0, 0, 0, 0.297406) 93.33%, rgba(0, 0, 0, 0.3) 100%);"
    },
    myDiscountImgSpan: {
      color: "#ff0000",
      position: "absolute",
      bottom: 0,
      padding: "28px",
      "@media (max-width: 766px)": {
        padding: "20px"
        },

    },
    body: {
      padding: "27.5px 32px",
      "@media (max-width: 766px)": {
        padding: "20px"
      }
    },
    footer: {
      padding: "27.5px 32px",
      "@media (max-width: 766px)": {
        padding: "20px"
      }
    }
  });

  const classes = useStyles();

  return (
    <div className={classes.myDiscountCard}>
      <div
        style={{ backgroundImage: "url(" + props.imgpath + ")" }}
        className={classes.myDiscountImg}>
        <div className={classes.myDiscountDegradation}>
          <span className={"semibold-h200 cl-secondary-100 " + classes.myDiscountImgSpan}>{props.header}</span>
        </div>
      </div>
      <div className={classes.body + " regular-b300"}>{props.body}</div>
      <div className={classes.footer}>
        <a className='semibold-b300 anchor'
          onClick={() => { window.open(props.footerpath, '_blank') }}>
          {t("MoreInfoBtnText")}<img loading="lazy"
            className="gotopageimg"
            alt="More info" src="/img/rightarrow.svg" /></a>
      </div>
    </div>
  );
}